import React from 'react';
import Dropzone, { DropzoneFile } from 'dropzone';
import { DataVendorSelector } from 'v2/common/DataVendorSelector';
import { DropzoneFileItem } from 'v2/common/DropzoneFileItem';
import { DataVendor } from 'v2/models';
import styles from './CompanyFileAssociation.module.scss';
import Checkbox from 'v2/common/CheckBox/Checkbox';

type CompanyFileAssociationProps = {
  file: Dropzone.DropzoneFile;
  isFileSelected: boolean;
  onFileCheckboxChange: (checkeFileSelectedd: boolean) => void;
  onFileDelete: (file: DropzoneFile) => void;
  dataVendor: DataVendor | null;
  onDataVendorChange: (dataVendor?: DataVendor) => void;
};

export function CompanyFileAssociation({
  file,
  isFileSelected,
  onFileCheckboxChange,
  onFileDelete,
  dataVendor,
  onDataVendorChange,
}: CompanyFileAssociationProps) {
  return (
    <div className={styles.companyFileMappingItem}>
      <div className={styles.fileItemOptions}>
        <Checkbox
          className={styles.checkbox}
          checked={isFileSelected}
          onChange={(e) => onFileCheckboxChange(Boolean(e.target.value))}
        />

        <div className={styles.companySearcherContainer}>
          <DataVendorSelector
            onChange={onDataVendorChange}
            value={dataVendor}
          />
        </div>
      </div>

      <DropzoneFileItem file={file} onDelete={onFileDelete} />
    </div>
  );
}
